module.exports = __webpack_public_path__ + "img/WFH-Fr.6036a271.png";